(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["built--button"] && !Shopify.designMode) return;
  try {
    (() => {
		// src/components/button/button.ts
		document.querySelectorAll(".tr-button").forEach((button) => {
			button.addEventListener("click", () => {
				console.log("tr-button clicked");
			});
		});
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-buy-buttons--recipient-form"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}

		// src/utilities/variant.ts
		var CART_ADD_EVENT = "cv:cartAdd";
		var CART_ERROR_EVENT = "cv:cartError";

		// src/components/cv-buy-buttons/components/recipient-form/recipient-form.ts
		var RecipientForm = class extends HTMLElement {
			abort;
			connectedCallback() {
				this.abort = new AbortController();
				const signal = this.abort.signal;
				this.checkbox.disabled = false;
				this.fallbackControl.disabled = true;
				this.offsetInput.value = String((/* @__PURE__ */ new Date()).getTimezoneOffset());
				this.addEventListener("change", this.handleToggle, { signal });
				document.addEventListener(CART_ADD_EVENT, this.handleCartAdd, { signal });
				document.addEventListener(CART_ERROR_EVENT, this.handleCartError, {
					signal
				});
				this.handleToggle();
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			handleToggle = () => {
				if (this.checkbox.checked) {
					this.disableableFields.forEach((field) => {
						field.disabled = false;
					});
					this.liveRegion.textContent = this.dataset.expandedAnnouncement ?? "";
					return;
				}
				this.recipientFields.forEach((field) => {
					field.value = "";
				});
				this.disableableFields.forEach((field) => {
					field.disabled = true;
				});
				this.clearErrors();
				this.liveRegion.textContent = this.dataset.collapsedAnnouncement ?? "";
			};
			handleCartAdd = () => {
				if (!this.checkbox.checked) return;
				this.checkbox.checked = false;
				this.handleToggle();
			};
			handleCartError = (event) => {
				if (!this.checkbox.checked) return;
				if (!isFieldErrors(event.detail.errors)) return;
				this.showErrors(event.detail.errors);
			};
			showErrors(errors) {
				this.clearErrors();
				this.errorSummary.hidden = false;
				Object.entries(errors).forEach(([field, messages]) => {
					const summary = messages.join(", ");
					const errorElement = this.querySelector(
						`[data-recipient-error-for="${field}"]`
					);
					const input = this.querySelector(
						`[data-recipient-field="${field}"]`
					);
					if (!errorElement || !input) return;
					requireElement(".error-message", errorElement).textContent = `${summary}.`;
					errorElement.classList.remove("hidden");
					this.errorList.appendChild(this.buildErrorLink(`#${input.id}`, summary));
					input.setAttribute("aria-invalid", "true");
					input.setAttribute("aria-describedby", errorElement.id);
				});
			}
			clearErrors() {
				this.errorSummary.hidden = true;
				this.errorList.replaceChildren();
				this.querySelectorAll("[data-recipient-error-for]").forEach(
					(errorElement) => {
						errorElement.classList.add("hidden");
						requireElement(".error-message", errorElement).textContent = "";
					}
				);
				this.recipientFields.forEach((input) => {
					input.setAttribute("aria-invalid", "false");
					input.removeAttribute("aria-describedby");
				});
			}
			buildErrorLink(target, message) {
				const item = document.createElement("li");
				const link = document.createElement("a");
				link.setAttribute("href", target);
				link.textContent = message;
				item.appendChild(link);
				item.className = "error-message";
				return item;
			}
			get checkbox() {
				return requireElement('input[type="checkbox"]', this);
			}
			get fallbackControl() {
				return requireElement("[data-recipient-fallback-control]", this);
			}
			get offsetInput() {
				return requireElement('input[name="properties[__shopify_offset]"]', this);
			}
			get liveRegion() {
				return requireElement("[data-recipient-live-region]", this);
			}
			get errorSummary() {
				return requireElement("[data-recipient-error-summary]", this);
			}
			get errorList() {
				return requireElement("ul", this.errorSummary);
			}
			get recipientFields() {
				return [...this.querySelectorAll("[data-recipient-field]")];
			}
			get disableableFields() {
				return [...this.recipientFields, this.offsetInput];
			}
		};
		function isFieldErrors(errors) {
			if (typeof errors !== "object" || errors === null || Array.isArray(errors)) {
				return false;
			}
			return Object.values(errors).every(
				(messages) => Array.isArray(messages) && messages.every((message) => typeof message === "string")
			);
		}
		if (!customElements.get("cv-recipient-form")) {
			customElements.define("cv-recipient-form", RecipientForm);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-buy-buttons"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}
		function readJsonIsland(selector, root, fallback) {
			const json = root.querySelector(selector)?.textContent;
			return json?.trim() ? JSON.parse(json) : fallback;
		}

		// src/utilities/variant.ts
		var VARIANT_CHANGE_EVENT = "cv:variantChange";
		var CART_ADD_EVENT = "cv:cartAdd";
		var CART_ERROR_EVENT = "cv:cartError";

		// src/components/cv-buy-buttons/cv-buy-buttons.ts
		var ADD_BUTTON = "button[type=submit]";
		var BuyButtons = class extends HTMLElement {
			abort;
			parsedPrices;
			connectedCallback() {
				this.abort = new AbortController();
				document.addEventListener(VARIANT_CHANGE_EVENT, this.handleVariantChange, {
					signal: this.abort.signal
				});
				this.addEventListener("submit", this.handleSubmit, {
					capture: true,
					signal: this.abort.signal
				});
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			handleSubmit = async (event) => {
				if (!(event.target instanceof HTMLFormElement)) return;
				event.preventDefault();
				const form = event.target;
				const button = requireElement(ADD_BUTTON, this);
				const error = requireElement("[data-error]", this);
				button.disabled = true;
				error.hidden = true;
				try {
					const response = await fetch(form.action, {
						method: "POST",
						body: new FormData(form),
						headers: {
							Accept: "application/javascript",
							"X-Requested-With": "XMLHttpRequest"
						}
					});
					const result = await response.json();
					if (result.status)
						throw new Error(
							String(
								typeof result.description === "string" && result.description || result.message || ""
							),
							{ cause: result.errors }
						);
					this.dispatchEvent(new CustomEvent(CART_ADD_EVENT, { bubbles: true }));
				} catch (caught) {
					const message = caught instanceof Error && caught.message !== "" ? caught.message : this.dataset.unavailableLabel ?? "";
					error.textContent = message;
					error.hidden = false;
					this.dispatchEvent(
						new CustomEvent(CART_ERROR_EVENT, {
							bubbles: true,
							detail: {
								message,
								errors: caught instanceof Error && caught.cause || message
							}
						})
					);
				} finally {
					button.disabled = false;
				}
			};
			handleVariantChange = (event) => {
				const variant = event.detail.variant;
				const button = requireElement(ADD_BUTTON, this);
				const label = requireElement("[data-label]", this);
				const compare = requireElement("[data-compare]", this);
				const price = requireElement("[data-price]", this);
				const idInput = requireElement("input[name=id]", this);
				button.removeAttribute("aria-label");
				if (!variant) {
					idInput.value = "";
					button.disabled = true;
					label.textContent = this.dataset.unavailableLabel ?? "";
					compare.textContent = "";
					compare.hidden = true;
					price.textContent = "";
					return;
				}
				const entry = this.prices[variant.id];
				idInput.value = String(variant.id);
				button.disabled = !variant.available;
				label.textContent = variant.available ? this.dataset.addLabel ?? "" : this.dataset.soldOutLabel ?? "";
				compare.textContent = entry?.compare ?? "";
				compare.hidden = !entry?.compare;
				price.textContent = entry?.price ?? "";
			};
			get prices() {
				this.parsedPrices ??= readJsonIsland("[data-cv-variant-prices]", this, {});
				return this.parsedPrices;
			}
		};
		if (!customElements.get("cv-buy-buttons")) {
			customElements.define("cv-buy-buttons", BuyButtons);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-carousel"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}
		function observeResize(target, callback, signal) {
			const observer = new ResizeObserver(callback);
			if (signal.aborted) return observer;
			observer.observe(target);
			signal.addEventListener("abort", () => observer.disconnect(), { once: true });
			return observer;
		}
		function frameBatch(callback, signal) {
			let handle = 0;
			signal.addEventListener(
				"abort",
				() => {
					if (handle) cancelAnimationFrame(handle);
				},
				{ once: true }
			);
			return () => {
				if (handle || signal.aborted) return;
				handle = requestAnimationFrame(() => {
					handle = 0;
					callback();
				});
			};
		}

		// src/utilities/scrollbarWidth.ts
		var SCROLLBAR_PROPERTY = "--cv-scrollbar-width";
		var installed = false;
		function observeScrollbarWidth() {
			if (installed) return;
			installed = true;
			publishScrollbarWidth();
			window.addEventListener("resize", publishScrollbarWidth, { passive: true });
		}
		function publishScrollbarWidth() {
			const width = window.innerWidth - document.documentElement.clientWidth;
			document.documentElement.style.setProperty(
				SCROLLBAR_PROPERTY,
				`${Math.max(0, width)}px`
			);
		}

		// src/components/cv-carousel/cv-carousel.ts
		var Direction = { previous: -1, next: 1 };
		var Carousel = class extends HTMLElement {
			abort;
			track;
			previous;
			next;
			connectedCallback() {
				this.abort = new AbortController();
				const { signal } = this.abort;
				this.track = requireElement(":scope > .cv-stack", this);
				this.previous = requireElement('[data-direction="prev"]', this);
				this.next = requireElement('[data-direction="next"]', this);
				if (this.classList.contains("cv-carousel--full-bleed")) {
					observeScrollbarWidth();
				}
				const scheduleSync = frameBatch(() => this.syncControls(), signal);
				this.previous.addEventListener(
					"click",
					() => this.page(Direction.previous),
					{ signal }
				);
				this.next.addEventListener("click", () => this.page(Direction.next), {
					signal
				});
				this.track.addEventListener("scroll", scheduleSync, {
					signal,
					passive: true
				});
				observeResize(this.track, scheduleSync, signal);
				const mutationObserver = new MutationObserver(scheduleSync);
				mutationObserver.observe(this.track, { childList: true });
				signal.addEventListener("abort", () => mutationObserver.disconnect());
				this.syncControls();
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			page(direction) {
				const itemStarts = this.itemStarts();
				const index = this.currentIndex(itemStarts) + direction;
				const target = Math.max(0, Math.min(index, itemStarts.length - 1));
				this.track.scrollTo({
					left: itemStarts[target] - this.snapGutter(),
					behavior: "smooth"
				});
			}
			currentIndex(itemStarts) {
				const current = this.track.scrollLeft + this.snapGutter();
				return itemStarts.reduce(
					(index, start, position) => start <= current + 1 ? position : index,
					0
				);
			}
			snapGutter() {
				return Number.parseFloat(
					getComputedStyle(this.track).scrollPaddingInlineStart
				) || 0;
			}
			itemStarts() {
				const trackLeft = this.track.getBoundingClientRect().left;
				return Array.from(this.track.children).map(
					(item) => item.getBoundingClientRect().left - trackLeft + this.track.scrollLeft
				);
			}
			syncControls() {
				const maxScroll = this.track.scrollWidth - this.track.clientWidth;
				this.previous.disabled = this.track.scrollLeft <= 1;
				this.next.disabled = this.track.scrollLeft >= maxScroll - 1;
			}
		};
		if (!customElements.get("cv-carousel")) {
			customElements.define("cv-carousel", Carousel);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-icon-cart"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/components/cv-icon-cart/cv-icon-cart.ts
		var CartIcon = class extends HTMLElement {
			abort;
			lastCount = 0;
			connectedCallback() {
				this.abort = new AbortController();
				const badge = this.querySelector(".cv-icon-cart__count");
				if (!badge) return;
				this.lastCount = Number.parseInt(badge.textContent ?? "", 10) || 0;
				document.addEventListener(
					"rebuy:cart.change",
					(event) => {
						const count = event.detail.cart.itemCount();
						badge.textContent = formatBadgeLabel(count);
						if (count !== this.lastCount) this.bump();
						this.lastCount = count;
					},
					{ signal: this.abort.signal }
				);
				this.addEventListener(
					"animationend",
					() => {
						this.classList.remove("cv-icon-cart--bump");
					},
					{ signal: this.abort.signal }
				);
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			bump() {
				this.classList.remove("cv-icon-cart--bump");
				requestAnimationFrame(() => {
					this.classList.add("cv-icon-cart--bump");
				});
			}
		};
		if (!customElements.get("cv-icon-cart")) {
			customElements.define("cv-icon-cart", CartIcon);
		}
		function formatBadgeLabel(count) {
			if (count > 99) return "99+";
			if (count > 0) return String(count);
			return "";
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-market-links"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/localizedPath.ts
		function localizedPath(path) {
			const root = (window.Shopify?.routes?.root ?? "/").replace(/\/$/, "");
			if (!root || !path.startsWith("/") || path.startsWith("//")) return path;
			const url = new URL(path, window.location.origin);
			if (url.pathname === root || url.pathname.startsWith(`${root}/`)) return path;
			url.pathname = root + url.pathname;
			return url.pathname + url.search + url.hash;
		}

		// src/components/cv-market-links/cv-market-links.ts
		function localizeLink(event) {
			const link = event.composedPath().find(
				(node) => node instanceof Element && node.matches("a[href]")
			);
			const href = link?.getAttribute("href");
			if (!link || !href) return;
			let resolved;
			try {
				resolved = new URL(href, window.location.href);
			} catch {
				return;
			}
			if (resolved.origin !== window.location.origin) return;
			const path = resolved.pathname + resolved.search + resolved.hash;
			const localized = localizedPath(path);
			if (localized !== path) link.setAttribute("href", localized);
		}
		function installMarketLinks(root = document) {
			root.addEventListener("click", localizeLink, true);
			root.addEventListener("auxclick", localizeLink, true);
		}
		installMarketLinks();
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-product-carousel"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// node_modules/requestidlecallback-polyfill/index.js
		window.requestIdleCallback = window.requestIdleCallback || function(cb) {
			var start = Date.now();
			return setTimeout(function() {
				cb({
					didTimeout: false,
					timeRemaining: function() {
						return Math.max(0, 50 - (Date.now() - start));
					}
				});
			}, 1);
		};
		window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
			clearTimeout(id);
		};

		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}

		// src/utilities/localizedPath.ts
		function localizedPath(path) {
			const root = (window.Shopify?.routes?.root ?? "/").replace(/\/$/, "");
			if (!root || !path.startsWith("/") || path.startsWith("//")) return path;
			const url = new URL(path, window.location.origin);
			if (url.pathname === root || url.pathname.startsWith(`${root}/`)) return path;
			url.pathname = root + url.pathname;
			return url.pathname + url.search + url.hash;
		}

		// src/utilities/fetchSection.ts
		async function fetchSection(sectionId, {
			params = {},
			path = window.location.pathname,
			signal
		} = {}) {
			const url = new URL(localizedPath(path), window.location.origin);
			url.search = String(
				new URLSearchParams({ section_id: sectionId, ...params })
			);
			const response = await fetch(url, { signal });
			if (!response.ok) {
				throw new Error(
					`fetchSection: HTTP ${response.status} ${response.statusText}`
				);
			}
			const parsed = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			);
			return parsed.querySelector('[id^="shopify-section-"]') ?? parsed.body;
		}

		// node_modules/es-toolkit/dist/function/debounce.mjs
		function debounce(func, debounceMs, { signal, edges } = {}) {
			let pendingThis = void 0;
			let pendingArgs = null;
			const leading = edges != null && edges.includes("leading");
			const trailing = edges == null || edges.includes("trailing");
			const invoke = () => {
				if (pendingArgs !== null) {
					func.apply(pendingThis, pendingArgs);
					pendingThis = void 0;
					pendingArgs = null;
				}
			};
			const onTimerEnd = () => {
				if (trailing) invoke();
				cancel();
			};
			let timeoutId = null;
			const schedule = () => {
				if (timeoutId != null) clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					timeoutId = null;
					onTimerEnd();
				}, debounceMs);
			};
			const cancelTimer = () => {
				if (timeoutId !== null) {
					clearTimeout(timeoutId);
					timeoutId = null;
				}
			};
			const cancel = () => {
				cancelTimer();
				pendingThis = void 0;
				pendingArgs = null;
			};
			const flush = () => {
				invoke();
			};
			const debounced = function(...args) {
				if (signal?.aborted) return;
				pendingThis = this;
				pendingArgs = args;
				const isFirstCall = timeoutId == null;
				schedule();
				if (leading && isFirstCall) invoke();
			};
			debounced.schedule = schedule;
			debounced.cancel = cancel;
			debounced.flush = flush;
			signal?.addEventListener("abort", cancel, { once: true });
			return debounced;
		}

		// src/utilities/legacyPubsub.ts
		var legacyEvents = {
			variantChange: "onvariant:change",
			cardSwatchInit: "swatch-more-card:init"
		};
		var publishLegacyCardSwatchInit = debounce(() => {
			document.dispatchEvent(new CustomEvent(legacyEvents.cardSwatchInit));
		}, 200);

		// src/components/cv-product-carousel/cv-product-carousel.ts
		var CARDS_SECTION_ID = "built--cv-product-carousel--cards";
		var INTERACTION_EVENTS = ["pointerenter", "focusin", "touchstart"];
		var ProductCarousel = class extends HTMLElement {
			abort;
			loaded = false;
			connectedCallback() {
				if (this.deferredCount() > 0) this.setupDeferredLoad();
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			deferredCount() {
				const count = Number(this.dataset.limit);
				return Number.isFinite(count) ? count : 0;
			}
			setupDeferredLoad() {
				this.abort = new AbortController();
				const { signal } = this.abort;
				const load = () => this.loadDeferred();
				scheduleIdle(load, signal);
				INTERACTION_EVENTS.forEach((event) => {
					this.addEventListener(event, load, { signal, passive: true });
				});
			}
			async loadDeferred() {
				if (this.loaded || !this.abort) return;
				this.loaded = true;
				const { signal } = this.abort;
				const track = requireElement(".cv-stack", this);
				try {
					const cards = await this.fetchCards(signal);
					track.append(...cards);
					publishLegacyCardSwatchInit();
				} catch (error) {
					if (signal.aborted) return;
					console.error("[cv-product-carousel] deferred load failed:", error);
				} finally {
					this.abort?.abort();
				}
			}
			async fetchCards(signal) {
				const handle = this.dataset.collectionHandle;
				if (!handle) throw new Error("missing data-collection-handle");
				const section = await fetchSection(CARDS_SECTION_ID, {
					path: `/collections/${encodeURIComponent(handle)}`,
					params: {
						offset: this.dataset.offset ?? "0",
						limit: this.dataset.limit ?? "0"
					},
					signal
				});
				return Array.from(section.querySelectorAll(":scope > li"));
			}
		};
		function scheduleIdle(callback, signal) {
			if (signal.aborted) return;
			const handle = window.requestIdleCallback(callback);
			signal.addEventListener("abort", () => window.cancelIdleCallback(handle), {
				once: true
			});
		}
		if (!customElements.get("cv-product-carousel")) {
			customElements.define("cv-product-carousel", ProductCarousel);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-product-model-debug"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/cvDataString.ts
		var FIELD_TOKEN = "[=]";
		var KEYED_FIELD = /^[a-z_]+\[=\]/;
		var STRUCTURE = /\[:+\]|\[=\]/;
		function parseCvData(payload, depth) {
			const level = depth ?? inferDepth(payload);
			const segments = payload.split(levelToken(level));
			const isList = segments.length > 1 && segments.at(-1) === "";
			if (isList) {
				return segments.filter((element) => element !== "").map((element) => parseCvData(element, level + 1));
			}
			const isRecord = segments.every((field) => KEYED_FIELD.test(field));
			if (isRecord) {
				return Object.fromEntries(
					segments.map((field) => {
						const [key, ...valueParts] = field.split(FIELD_TOKEN);
						return [key, parseCvData(valueParts.join(FIELD_TOKEN), level + 1)];
					})
				);
			}
			const isScalar = segments.length === 1 && !STRUCTURE.test(payload);
			if (isScalar) {
				return payload;
			}
			throw new Error(
				`cv data fragment "${truncate(payload)}" is not a list, record, or scalar at depth ${level}`
			);
		}
		function levelToken(depth) {
			return `[${":".repeat(depth)}]`;
		}
		function inferDepth(payload) {
			const tokens = payload.match(/\[:+\]/g);
			if (!tokens) return 1;
			return Math.min(...tokens.map((token) => token.length - 2));
		}
		function truncate(fragment) {
			return fragment.length > 60 ? `${fragment.slice(0, 60)}\u2026` : fragment;
		}

		// src/utilities/productModel.ts
		function parseProductModel(payload) {
			return parseCvData(payload);
		}

		// src/utilities/variant.ts
		var VARIANT_CHANGE_EVENT = "cv:variantChange";

		// src/components/cv-product-model-debug/cv-product-model-debug.ts
		var ProductModelDebug = class extends HTMLElement {
			abort;
			connectedCallback() {
				this.renderPanel();
				this.abort = new AbortController();
				document.addEventListener(VARIANT_CHANGE_EVENT, this.logIslandEvent, {
					signal: this.abort.signal
				});
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			renderPanel() {
				const payload = this.querySelector("[js-payload]")?.textContent?.trim();
				const summary = this.querySelector("[js-summary]");
				const json = this.querySelector("[js-json]");
				if (payload === void 0) return;
				let model;
				try {
					model = parseProductModel(payload);
				} catch (error) {
					const message = `failed to parse payload: ${error}`;
					summary?.replaceChildren(line(message));
					if (json) json.textContent = message;
					return;
				}
				if (json) json.textContent = JSON.stringify(model, void 0, 2);
				summary?.replaceChildren(
					line(`is_bundle: ${model.is_bundle}`),
					line(`display_title: ${model.display_title}`),
					...model.warnings.map(
						(warning) => line(`\u26A0 ${warning}`, "cv-product-model-debug__warning")
					),
					...model.options.flatMap(renderOption),
					...renderColours(model.colours)
				);
			}
			logIslandEvent = (event) => {
				const variant = event.detail.variant;
				this.log(
					variant ? `${VARIANT_CHANGE_EVENT} \u2192 ${variant.id} (${variant.title})` : `${VARIANT_CHANGE_EVENT} \u2192 no matching variant`
				);
			};
			log(message) {
				const list = this.querySelector("[js-event-log]");
				if (!list) return;
				const entry = document.createElement("li");
				entry.textContent = `${(/* @__PURE__ */ new Date()).toLocaleTimeString()} ${message}`;
				list.append(entry);
				while (list.children.length > 20) list.firstElementChild?.remove();
			}
		};
		function renderOption(option) {
			const slot = option.position === "" ? "no slot" : `slot ${option.position}`;
			return [
				line(
					`${option.name} (${option.role}, ${slot})`,
					"cv-product-model-debug__option"
				),
				...option.values.map(renderValue)
			];
		}
		function renderValue(value) {
			return line(
				[
					`[${marker(value.initial_selected)}] ${value.label}`,
					`${value.kind} #${value.id}`,
					value.url,
					availability(value.available)
				].join(" \xB7 "),
				"cv-product-model-debug__value"
			);
		}
		function renderColours(colours) {
			if (colours.length === 0) return [];
			return [
				line(`colours (${colours.length})`, "cv-product-model-debug__option"),
				...colours.map(renderColour)
			];
		}
		function renderColour(colour) {
			return line(
				[
					`[${marker(colour.initial_selected)}] ${colour.label}`,
					colour.handle,
					colour.color || "no colour",
					colour.image_url || "no image",
					availability(colour.available),
					colour.badge || "no badge"
				].join(" \xB7 "),
				"cv-product-model-debug__value"
			);
		}
		function line(text, className) {
			const element = document.createElement("p");
			if (className !== void 0) element.className = className;
			element.textContent = text;
			return element;
		}
		function marker(selected) {
			return selected === "true" ? "x" : " ";
		}
		function availability(available) {
			return available === "true" ? "available" : "unavailable";
		}
		if (!customElements.get("cv-product-model-debug")) {
			customElements.define("cv-product-model-debug", ProductModelDebug);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-product-swatch"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function isModifiedClick(event) {
			if (event.button !== 0) return true;
			return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
		}

		// src/components/cv-product-swatch/cv-product-swatch.ts
		var SWATCH_SELECT_EVENT = "cv:swatchSelect";
		var ProductSwatch = class extends HTMLElement {
			abort;
			pending = 0;
			connectedCallback() {
				this.abort = new AbortController();
				this.addEventListener("click", this.handleClick, {
					signal: this.abort.signal
				});
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			get handle() {
				return this.getAttribute("handle") ?? "";
			}
			/** Read off the anchor so the URL lives in the markup once. */
			get url() {
				return this.link?.getAttribute("href") ?? "";
			}
			get loading() {
				return this.hasAttribute("loading");
			}
			set loading(value) {
				this.toggleAttribute("loading", value);
			}
			/** Settled, not resolved: a failed load must still clear the spinner. */
			loadUntil(work) {
				this.pending += 1;
				this.loading = true;
				void Promise.allSettled([work]).then(() => {
					this.pending -= 1;
					if (this.pending === 0) this.loading = false;
				});
			}
			get link() {
				return this.querySelector("a") ?? void 0;
			}
			handleClick = (event) => {
				if (isModifiedClick(event)) return;
				const work = [];
				const selection = new CustomEvent(SWATCH_SELECT_EVENT, {
					bubbles: true,
					composed: true,
					cancelable: true,
					detail: {
						handle: this.handle,
						url: this.url,
						waitUntil(pending) {
							work.push(pending);
						}
					}
				});
				this.dispatchEvent(selection);
				if (work.length === 0 && !selection.defaultPrevented) return;
				event.preventDefault();
				work.forEach((pending) => this.loadUntil(pending));
			};
		};
		if (!customElements.get("cv-product-swatch")) {
			customElements.define("cv-product-swatch", ProductSwatch);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-product-swatches"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function readJsonIsland(selector, root, fallback) {
			const json = root.querySelector(selector)?.textContent;
			return json?.trim() ? JSON.parse(json) : fallback;
		}
		function isModifiedClick(event) {
			if (event.button !== 0) return true;
			return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
		}

		// src/components/cv-product-swatch/cv-product-swatch.ts
		var SWATCH_SELECT_EVENT = "cv:swatchSelect";
		var ProductSwatch = class extends HTMLElement {
			abort;
			pending = 0;
			connectedCallback() {
				this.abort = new AbortController();
				this.addEventListener("click", this.handleClick, {
					signal: this.abort.signal
				});
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			get handle() {
				return this.getAttribute("handle") ?? "";
			}
			/** Read off the anchor so the URL lives in the markup once. */
			get url() {
				return this.link?.getAttribute("href") ?? "";
			}
			get loading() {
				return this.hasAttribute("loading");
			}
			set loading(value) {
				this.toggleAttribute("loading", value);
			}
			/** Settled, not resolved: a failed load must still clear the spinner. */
			loadUntil(work) {
				this.pending += 1;
				this.loading = true;
				void Promise.allSettled([work]).then(() => {
					this.pending -= 1;
					if (this.pending === 0) this.loading = false;
				});
			}
			get link() {
				return this.querySelector("a") ?? void 0;
			}
			handleClick = (event) => {
				if (isModifiedClick(event)) return;
				const work = [];
				const selection = new CustomEvent(SWATCH_SELECT_EVENT, {
					bubbles: true,
					composed: true,
					cancelable: true,
					detail: {
						handle: this.handle,
						url: this.url,
						waitUntil(pending) {
							work.push(pending);
						}
					}
				});
				this.dispatchEvent(selection);
				if (work.length === 0 && !selection.defaultPrevented) return;
				event.preventDefault();
				work.forEach((pending) => this.loadUntil(pending));
			};
		};
		if (!customElements.get("cv-product-swatch")) {
			customElements.define("cv-product-swatch", ProductSwatch);
		}

		// src/utilities/localizedPath.ts
		function localizedPath(path) {
			const root = (window.Shopify?.routes?.root ?? "/").replace(/\/$/, "");
			if (!root || !path.startsWith("/") || path.startsWith("//")) return path;
			const url = new URL(path, window.location.origin);
			if (url.pathname === root || url.pathname.startsWith(`${root}/`)) return path;
			url.pathname = root + url.pathname;
			return url.pathname + url.search + url.hash;
		}

		// src/utilities/fetchSection.ts
		async function fetchSection(sectionId, {
			params = {},
			path = window.location.pathname,
			signal
		} = {}) {
			const url = new URL(localizedPath(path), window.location.origin);
			url.search = String(
				new URLSearchParams({ section_id: sectionId, ...params })
			);
			const response = await fetch(url, { signal });
			if (!response.ok) {
				throw new Error(
					`fetchSection: HTTP ${response.status} ${response.statusText}`
				);
			}
			const parsed = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			);
			return parsed.querySelector('[id^="shopify-section-"]') ?? parsed.body;
		}

		// src/utilities/sectionSwap.ts
		var sectionSwappedEvent = "cv:sectionSwapped";
		var fetchTimeout = 8e3;
		var activeSwap = /* @__PURE__ */ Symbol.for("cv.sectionSwap.active");
		async function swapSection(island, url) {
			const destination = localizedPath(url);
			const section = island.closest(".shopify-section");
			if (!section) {
				window.location.replace(destination);
				return;
			}
			section[activeSwap]?.abort("superseded");
			const swap = new AbortController();
			section[activeSwap] = swap;
			section.setAttribute("aria-busy", "true");
			const timeout = setTimeout(() => swap.abort("timeout"), fetchTimeout);
			try {
				const focused = captureFocus(section);
				const fresh = await fetchDestination(section, destination, swap.signal);
				if (swap.signal.aborted) return;
				section.replaceChildren(...document.adoptNode(fresh).childNodes);
				updateUrlAndTitle(section, destination);
				announceSwap(section, destination);
				restoreFocus(section, focused);
			} catch {
				if (swap.signal.reason === "superseded") return;
				window.location.replace(destination);
			} finally {
				clearTimeout(timeout);
				if (section[activeSwap] === swap) {
					section[activeSwap] = void 0;
					section.removeAttribute("aria-busy");
				}
			}
		}
		async function fetchDestination(section, url, signal) {
			const sectionId = section.id.replace("shopify-section-", "");
			return fetchSection(sectionId, { path: url, signal });
		}
		function updateUrlAndTitle(section, url) {
			window.history.replaceState({}, "", url);
			const title = sectionMeta(section).title;
			if (title) document.title = title;
		}
		function announceSwap(section, url) {
			section.dispatchEvent(
				new CustomEvent(sectionSwappedEvent, {
					bubbles: true,
					detail: { name: sectionMeta(section).name, url }
				})
			);
		}
		function captureFocus(section) {
			const active = document.activeElement;
			if (!(active instanceof HTMLElement) || !section.contains(active)) {
				return void 0;
			}
			const index = Array.from(
				section.getElementsByTagName(active.tagName)
			).indexOf(active);
			return {
				tagName: active.tagName,
				index
			};
		}
		function restoreFocus(section, focused) {
			if (!focused) return;
			const counterpart = section.getElementsByTagName(focused.tagName)[focused.index];
			if (counterpart instanceof HTMLElement) counterpart.focus();
		}
		function sectionMeta(section) {
			return readJsonIsland("[data-cv-section-meta]", section, {});
		}

		// src/components/cv-product-swatches/cv-product-swatches.ts
		var ProductSwatches = class extends HTMLElement {
			abort;
			connectedCallback() {
				if (!this.hasAttribute("swap")) return;
				this.abort = new AbortController();
				this.addEventListener(SWATCH_SELECT_EVENT, this.handleSelect, {
					signal: this.abort.signal
				});
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			handleSelect = (event) => {
				const swatch = event.target.closest("cv-product-swatch");
				if (swatch?.hasAttribute("selected")) {
					event.preventDefault();
					return;
				}
				event.detail.waitUntil(swapSection(this, event.detail.url));
			};
		};
		if (!customElements.get("cv-product-swatches")) {
			customElements.define("cv-product-swatches", ProductSwatches);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-tabs"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function observeResize(target, callback, signal) {
			const observer = new ResizeObserver(callback);
			if (signal.aborted) return observer;
			observer.observe(target);
			signal.addEventListener("abort", () => observer.disconnect(), { once: true });
			return observer;
		}
		function flushLayout(element) {
			element.getBoundingClientRect();
		}

		// src/components/cv-tabs/cv-tabs.ts
		var PANEL_SELECTOR = ":scope > cv-tab";
		var LABEL_SELECTOR = ":scope > cv-tab-label";
		var TAB_SELECTOR = '[role="tab"]';
		var SELECTED_TAB_SELECTOR = '[role="tab"][aria-selected="true"]';
		var tabCount = 0;
		var Tabs = class extends HTMLElement {
			abort;
			tablist;
			indicator;
			connectedCallback() {
				if (this.panels.length === 0) return;
				const abort = new AbortController();
				this.abort = abort;
				const tablist = this.tablist ?? this.build();
				const { signal } = abort;
				observeResize(tablist, () => this.moveIndicator(false), signal);
				tablist.addEventListener("click", this.handleClick, { signal });
				tablist.addEventListener("keydown", this.handleKeydown, { signal });
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			build() {
				const tablist = document.createElement("div");
				tablist.className = "cv-tabs__list";
				tablist.setAttribute("role", "tablist");
				this.tablist = tablist;
				this.panels.forEach((panel) => tablist.append(this.createTabButton(panel)));
				this.indicator = document.createElement("span");
				this.indicator.className = "cv-tabs__indicator";
				this.indicator.setAttribute("aria-hidden", "true");
				tablist.append(this.indicator);
				this.prepend(tablist);
				this.classList.add("cv-tabs--ready");
				const firstTab = tablist.querySelector(TAB_SELECTOR);
				if (firstTab) this.select(firstTab, false);
				return tablist;
			}
			select(tab, animate = true) {
				const panelId = tab.getAttribute("aria-controls");
				this.tabs.forEach((candidate) => {
					const selected = candidate === tab;
					candidate.setAttribute("aria-selected", String(selected));
					candidate.tabIndex = selected ? 0 : -1;
				});
				this.panels.forEach((panel) => {
					panel.toggleAttribute("hidden", panel.id !== panelId);
				});
				this.moveIndicator(animate);
			}
			moveIndicator(animate = true) {
				const indicator = this.indicator;
				const tab = this.selectedTab;
				if (!indicator || !tab) return;
				if (!animate) indicator.style.transition = "none";
				indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
				indicator.style.inlineSize = `${tab.offsetWidth}px`;
				if (!animate) {
					flushLayout(indicator);
					indicator.style.transition = "";
				}
			}
			handleClick = (event) => {
				if (!(event.target instanceof Element)) return;
				const tab = event.target.closest(TAB_SELECTOR);
				if (!tab) return;
				this.select(tab);
				tab.focus();
			};
			handleKeydown = (event) => {
				const current = this.selectedTab;
				if (!current) return;
				const tabs = this.tabs;
				const index = tabs.indexOf(current);
				const lastIndex = tabs.length - 1;
				let nextIndex;
				switch (event.key) {
					case "ArrowRight":
						nextIndex = index === lastIndex ? 0 : index + 1;
						break;
					case "ArrowLeft":
						nextIndex = index === 0 ? lastIndex : index - 1;
						break;
					case "Home":
						nextIndex = 0;
						break;
					case "End":
						nextIndex = lastIndex;
						break;
					default:
						return;
				}
				event.preventDefault();
				const next = tabs[nextIndex];
				this.select(next);
				next.focus();
			};
			get tabs() {
				return Array.from(
					this.tablist?.querySelectorAll(TAB_SELECTOR) ?? []
				);
			}
			get panels() {
				return Array.from(this.querySelectorAll(PANEL_SELECTOR));
			}
			get selectedTab() {
				return this.tablist?.querySelector(SELECTED_TAB_SELECTOR) ?? void 0;
			}
			createTabButton(panel) {
				const id = tabCount++;
				const tabId = `cv-tab-${id}`;
				const panelId = `cv-panel-${id}`;
				panel.setAttribute("role", "tabpanel");
				panel.id = panelId;
				panel.setAttribute("aria-labelledby", tabId);
				panel.tabIndex = 0;
				const button = document.createElement("button");
				button.className = "cv-tabs__tab";
				button.type = "button";
				button.id = tabId;
				button.setAttribute("role", "tab");
				button.setAttribute("aria-controls", panelId);
				const richLabel = panel.querySelector(LABEL_SELECTOR);
				if (richLabel) {
					button.append(...Array.from(richLabel.childNodes));
					richLabel.remove();
				} else {
					button.textContent = panel.getAttribute("label") || "Tab";
				}
				return button;
			}
		};
		if (!customElements.get("cv-tabs")) {
			customElements.define("cv-tabs", Tabs);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["built--cv-variant-picker"] && !Shopify.designMode) return;
  try {
    "use strict";
	(() => {
		// src/utilities/dom.ts
		function readJsonIsland(selector, root, fallback) {
			const json = root.querySelector(selector)?.textContent;
			return json?.trim() ? JSON.parse(json) : fallback;
		}

		// node_modules/es-toolkit/dist/function/debounce.mjs
		function debounce(func, debounceMs, { signal, edges } = {}) {
			let pendingThis = void 0;
			let pendingArgs = null;
			const leading = edges != null && edges.includes("leading");
			const trailing = edges == null || edges.includes("trailing");
			const invoke = () => {
				if (pendingArgs !== null) {
					func.apply(pendingThis, pendingArgs);
					pendingThis = void 0;
					pendingArgs = null;
				}
			};
			const onTimerEnd = () => {
				if (trailing) invoke();
				cancel();
			};
			let timeoutId = null;
			const schedule = () => {
				if (timeoutId != null) clearTimeout(timeoutId);
				timeoutId = setTimeout(() => {
					timeoutId = null;
					onTimerEnd();
				}, debounceMs);
			};
			const cancelTimer = () => {
				if (timeoutId !== null) {
					clearTimeout(timeoutId);
					timeoutId = null;
				}
			};
			const cancel = () => {
				cancelTimer();
				pendingThis = void 0;
				pendingArgs = null;
			};
			const flush = () => {
				invoke();
			};
			const debounced = function(...args) {
				if (signal?.aborted) return;
				pendingThis = this;
				pendingArgs = args;
				const isFirstCall = timeoutId == null;
				schedule();
				if (leading && isFirstCall) invoke();
			};
			debounced.schedule = schedule;
			debounced.cancel = cancel;
			debounced.flush = flush;
			signal?.addEventListener("abort", cancel, { once: true });
			return debounced;
		}

		// src/utilities/legacyPubsub.ts
		var legacyEvents = {
			variantChange: "onvariant:change",
			cardSwatchInit: "swatch-more-card:init"
		};
		var publishLegacyCardSwatchInit = debounce(() => {
			document.dispatchEvent(new CustomEvent(legacyEvents.cardSwatchInit));
		}, 200);
		function publishLegacyVariantChange(variant, sectionId) {
			if (typeof publish === "function" && typeof PUB_SUB_EVENTS === "object" && PUB_SUB_EVENTS?.variantChange) {
				publish(PUB_SUB_EVENTS.variantChange, {
					data: { sectionId, variant }
				});
			}
			document.dispatchEvent(
				new CustomEvent(legacyEvents.variantChange, {
					detail: { currentVariant: variant }
				})
			);
		}

		// src/utilities/localizedPath.ts
		function localizedPath(path) {
			const root = (window.Shopify?.routes?.root ?? "/").replace(/\/$/, "");
			if (!root || !path.startsWith("/") || path.startsWith("//")) return path;
			const url = new URL(path, window.location.origin);
			if (url.pathname === root || url.pathname.startsWith(`${root}/`)) return path;
			url.pathname = root + url.pathname;
			return url.pathname + url.search + url.hash;
		}

		// src/utilities/fetchSection.ts
		async function fetchSection(sectionId, {
			params = {},
			path = window.location.pathname,
			signal
		} = {}) {
			const url = new URL(localizedPath(path), window.location.origin);
			url.search = String(
				new URLSearchParams({ section_id: sectionId, ...params })
			);
			const response = await fetch(url, { signal });
			if (!response.ok) {
				throw new Error(
					`fetchSection: HTTP ${response.status} ${response.statusText}`
				);
			}
			const parsed = new DOMParser().parseFromString(
				await response.text(),
				"text/html"
			);
			return parsed.querySelector('[id^="shopify-section-"]') ?? parsed.body;
		}

		// src/utilities/sectionSwap.ts
		var sectionSwappedEvent = "cv:sectionSwapped";
		var fetchTimeout = 8e3;
		var activeSwap = /* @__PURE__ */ Symbol.for("cv.sectionSwap.active");
		async function swapSection(island, url) {
			const destination = localizedPath(url);
			const section = island.closest(".shopify-section");
			if (!section) {
				window.location.replace(destination);
				return;
			}
			section[activeSwap]?.abort("superseded");
			const swap = new AbortController();
			section[activeSwap] = swap;
			section.setAttribute("aria-busy", "true");
			const timeout = setTimeout(() => swap.abort("timeout"), fetchTimeout);
			try {
				const focused = captureFocus(section);
				const fresh = await fetchDestination(section, destination, swap.signal);
				if (swap.signal.aborted) return;
				section.replaceChildren(...document.adoptNode(fresh).childNodes);
				updateUrlAndTitle(section, destination);
				announceSwap(section, destination);
				restoreFocus(section, focused);
			} catch {
				if (swap.signal.reason === "superseded") return;
				window.location.replace(destination);
			} finally {
				clearTimeout(timeout);
				if (section[activeSwap] === swap) {
					section[activeSwap] = void 0;
					section.removeAttribute("aria-busy");
				}
			}
		}
		function onSectionSwapped(listener, { name, signal }) {
			document.addEventListener(
				sectionSwappedEvent,
				(event) => {
					if (name && event.detail.name !== name) return;
					listener(event.detail, event.target);
				},
				{ signal }
			);
		}
		async function fetchDestination(section, url, signal) {
			const sectionId = section.id.replace("shopify-section-", "");
			return fetchSection(sectionId, { path: url, signal });
		}
		function updateUrlAndTitle(section, url) {
			window.history.replaceState({}, "", url);
			const title = sectionMeta(section).title;
			if (title) document.title = title;
		}
		function announceSwap(section, url) {
			section.dispatchEvent(
				new CustomEvent(sectionSwappedEvent, {
					bubbles: true,
					detail: { name: sectionMeta(section).name, url }
				})
			);
		}
		function captureFocus(section) {
			const active = document.activeElement;
			if (!(active instanceof HTMLElement) || !section.contains(active)) {
				return void 0;
			}
			const index = Array.from(
				section.getElementsByTagName(active.tagName)
			).indexOf(active);
			return {
				tagName: active.tagName,
				index
			};
		}
		function restoreFocus(section, focused) {
			if (!focused) return;
			const counterpart = section.getElementsByTagName(focused.tagName)[focused.index];
			if (counterpart instanceof HTMLElement) counterpart.focus();
		}
		function sectionMeta(section) {
			return readJsonIsland("[data-cv-section-meta]", section, {});
		}

		// src/utilities/selectionStore.ts
		var STORAGE_KEY = "cv-buy-box-selections";
		var HISTORY_LIMIT = 10;
		function readSelections() {
			try {
				const raw = window.localStorage.getItem(STORAGE_KEY);
				const parsed = raw === null ? {} : JSON.parse(raw);
				if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
					return {};
				}
				return Object.fromEntries(
					Object.entries(parsed).filter(
						(entry) => Array.isArray(entry[1]) && entry[1].every((label) => typeof label === "string")
					)
				);
			} catch {
				return {};
			}
		}
		function storeSelection(optionName, label) {
			try {
				const selections = readSelections();
				const history = [
					label,
					...(selections[optionName] ?? []).filter((known) => known !== label)
				].slice(0, HISTORY_LIMIT);
				window.localStorage.setItem(
					STORAGE_KEY,
					JSON.stringify({ ...selections, [optionName]: history })
				);
			} catch {
			}
		}

		// src/utilities/variant.ts
		var VARIANT_CHANGE_EVENT = "cv:variantChange";
		var CART_ADD_EVENT = "cv:cartAdd";

		// src/components/cv-variant-picker/legacySectionReinit.ts
		var reinitializeEvents = [
			// Rebinds the Details + Care / Shipping + Returns accordions.
			"pdp-accordion:init",
			// Rebuilds the mobile media gallery slider.
			"mobile-media-slider:init",
			// Rebinds the "You'll Love It With" upsell widget.
			"upsellPDP:init"
		].map((name) => () => document.dispatchEvent(new CustomEvent(name)));
		function bridgeSectionSwapsToLegacy(signal) {
			onSectionSwapped(reinitializeLegacyWidgets, {
				name: "main-product",
				signal
			});
		}
		function reinitializeLegacyWidgets() {
			[
				// Yotpo has two widget generations here: initWidgets for the new
				// yotpo-widget-instance mounts, refreshWidgets for the old bottomLine
				// stars under the title (which legacy swaps forget to refresh).
				() => typeof yotpoWidgetsContainer === "object" && yotpoWidgetsContainer.initWidgets(),
				() => typeof yotpo === "object" && yotpo.refreshWidgets(),
				// Re-renders the "as low as $X/mo" installment promo for new prices.
				() => typeof affirm === "object" && affirm.ui?.refresh(),
				...reinitializeEvents
			].forEach((reinit) => {
				try {
					reinit();
				} catch {
				}
			});
		}

		// src/components/cv-variant-picker/cv-variant-picker.ts
		var VariantPicker = class extends HTMLElement {
			abort;
			parsedVariants;
			connectedCallback() {
				this.abort = new AbortController();
				bridgeSectionSwapsToLegacy(this.abort.signal);
				this.addEventListener("change", this.handleChange, {
					signal: this.abort.signal
				});
				document.addEventListener(CART_ADD_EVENT, this.handleCartAdd, {
					signal: this.abort.signal
				});
				queueMicrotask(() => this.hydrate());
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			// --- Flows: land, change, tell everyone ---------------------------
			hydrate() {
				const selections = this.rememberedSelections;
				const siblingUrl = this.rememberedSiblingUrl(selections);
				if (siblingUrl) {
					void swapSection(this, siblingUrl);
					return;
				}
				this.restoreSelections(selections);
				const [anchor] = this.selects;
				if (anchor) this.resolveInvalidCombo(anchor);
				this.removePlaceholders();
				this.annotateAvailability();
				this.announce();
			}
			// The skeleton placeholder has done its job once real values are in;
			// left behind it lingers as a blank first entry in the dropdown.
			removePlaceholders() {
				this.selects.forEach((select) => {
					select.querySelector('option[value=""]')?.remove();
				});
			}
			handleChange = (event) => {
				if (!(event.target instanceof HTMLSelectElement)) return;
				const selected = event.target.selectedOptions[0];
				if (!selected) return;
				this.remember(event.target, selected);
				if (this.ownsValue(selected)) {
					this.resolveInvalidCombo(event.target);
					this.announce();
				} else {
					const { url } = selected.dataset;
					if (url) void swapSection(this, url);
				}
			};
			announce() {
				const variant = this.variantsMatching(this.selectedLabels)[0];
				this.writeVariantParam(variant);
				this.dispatchEvent(
					new CustomEvent(VARIANT_CHANGE_EVENT, {
						bubbles: true,
						detail: { variant }
					})
				);
				if (variant) publishLegacyVariantChange(variant, this.dataset.sectionId);
			}
			// --- Selection memory: restore, redirect, remember -----------------
			// Someone following a shared ?variant= link should see exactly what the
			// sender picked, so remembered selections sit that case out.
			get rememberedSelections() {
				const explicit = new URL(window.location.href).searchParams.has("variant");
				return explicit ? {} : readSelections();
			}
			// The catalog splits some sizes across sibling products (F/Q and K/CK
			// sheet sets are separate products). When the shopper's remembered size
			// only exists here as a sibling's value, this page cannot select it, so
			// we send them to the sibling instead. On that page the size is one of
			// the product's own values, so it hydrates normally: no redirect loop.
			rememberedSiblingUrl(selections) {
				return this.selects.map((select) => this.rememberedOption(select, selections)).find(
					(option) => option && option.dataset.url !== this.dataset.productUrl
				)?.dataset.url;
			}
			restoreSelections(selections) {
				this.selects.forEach((select) => {
					const target = this.rememberedOption(select, selections) ?? select.querySelector("option[data-initial]");
					if (target) select.value = target.value;
				});
			}
			rememberedOption(select, selections) {
				const history = selections[select.dataset.optionName ?? ""] ?? [];
				const options = [...select.options];
				return history.map((label) => options.find((option) => option.dataset.label === label)).find(Boolean);
			}
			remember(select, option) {
				const optionName = select.dataset.optionName;
				const label = option.dataset.label;
				if (optionName && label) storeSelection(optionName, label);
			}
			// A successful add is intent for every option, including landing defaults
			// the shopper never touched.
			handleCartAdd = () => {
				this.selects.forEach((select) => {
					const selected = select.selectedOptions[0];
					if (selected) this.remember(select, selected);
				});
			};
			// --- Invalid-combo correction ---------------------------------------
			// A new choice can leave the selection matching no variant at all (pick
			// King, then Side Open, when no King/Side Open exists). Rather than
			// stranding the shopper on an invalid combo, move each conflicting
			// select to something that works with the new choice: its remembered
			// labels newest-first, then its default. The select the shopper just
			// changed never moves, and these corrections are never written to the
			// store.
			resolveInvalidCombo(changed) {
				const selections = readSelections();
				this.selects.forEach((select) => {
					if (select === changed) return;
					if (this.variantsMatching(this.selectedLabels).length > 0) return;
					const replacement = this.candidatesFor(select, selections).find(
						(option) => this.matchesWith(select, option)
					);
					if (replacement) select.value = replacement.value;
				});
			}
			// A conflicting select's candidates: its remembered labels newest-first,
			// then its default.
			candidatesFor(select, selections) {
				const remembered = (selections[select.dataset.optionName ?? ""] ?? []).map(
					(label) => [...select.options].find(
						(option) => option.dataset.label === label && this.ownsValue(option)
					)
				);
				const initial = select.querySelector(
					"option[data-initial]"
				);
				return [...remembered, initial].filter(
					(option) => Boolean(option)
				);
			}
			// Would a variant exist if this select moved to this option?
			matchesWith(select, option) {
				const labels = [...this.selectedLabels];
				labels[this.controls.indexOf(select)] = option.dataset.label ?? "";
				return this.variantsMatching(labels).length > 0;
			}
			// --- Variant matching and page state --------------------------------
			// Picking a value that belongs to another product means leaving for that
			// product's page, not swapping variants here. Values of kind "product"
			// are entire products themselves, so they always mean leaving.
			ownsValue(option) {
				return option.dataset.kind !== "product" && option.dataset.url === this.dataset.productUrl;
			}
			annotateAvailability() {
				this.controls.forEach((control) => {
					if (!(control instanceof HTMLSelectElement)) return;
					const slot = readSlot(control);
					[...control.options].forEach((option) => {
						const label = option.dataset.label;
						if (label === void 0) return;
						if (option.dataset.url !== this.dataset.productUrl) return;
						if (option.dataset.kind === "product") return;
						const inStock = this.variants.some(
							(variant) => variant.options[slot] === label && variant.available
						);
						option.textContent = inStock ? label : `${label} (${this.dataset.soldOutLabel})`;
					});
				});
			}
			// Undefined labels are skipped. When the size select is the only control
			// and it holds sibling products, nothing is compared, so the product's
			// single "Default Title" variant matches.
			variantsMatching(labels) {
				const slots = this.controls.map(readSlot);
				return this.variants.filter(
					(variant) => labels.every(
						(label, index) => label === void 0 || variant.options[slots[index]] === label
					)
				);
			}
			writeVariantParam(variant) {
				const url = new URL(window.location.href);
				if (variant) {
					url.searchParams.set("variant", String(variant.id));
				} else {
					url.searchParams.delete("variant");
				}
				window.history.replaceState({}, "", url);
			}
			// --- DOM reads -------------------------------------------------------
			get controls() {
				return [
					...this.querySelectorAll("select, [data-fixed-label]")
				];
			}
			get selects() {
				return [...this.querySelectorAll("select")];
			}
			// Picking a sibling product (like a size that is its own product) says
			// which page you are on, not which variant you want, so that label is
			// undefined and variant matching ignores it.
			get selectedLabels() {
				return this.controls.map((control) => {
					if (!(control instanceof HTMLSelectElement)) {
						return control.dataset.fixedLabel ?? "";
					}
					const selected = control.selectedOptions[0];
					if (selected?.dataset.kind === "product") return void 0;
					return selected?.dataset.label ?? "";
				});
			}
			get variants() {
				this.parsedVariants ??= readJsonIsland("[data-cv-variants]", this, []);
				return this.parsedVariants;
			}
		};
		function readSlot(control) {
			return Number(control.dataset.optionSlot || -1);
		}
		if (!customElements.get("cv-variant-picker")) {
			customElements.define("cv-variant-picker", VariantPicker);
		}
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-country-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cv-country-selector')) {
		customElements.define(
			'cv-country-selector',
			class extends HTMLElement {
				connectedCallback() {
					this.abort = new AbortController();

					this.addEventListener(
						'click',
						(event) => {
							if (event.target.closest('.cv-country-selector__trigger')) {
								this.toggle();
							} else if (
								event.target.classList.contains('cv-country-selector__backdrop')
							) {
								this.close();
							}
						},
						{ signal: this.abort.signal }
					);
				}

				disconnectedCallback() {
					this.abort.abort();
				}

				get trigger() {
					return this.querySelector('.cv-country-selector__trigger');
				}

				get popover() {
					return this.querySelector('.cv-country-selector__popover');
				}

				toggle() {
					if (this.popover.hidden) {
						this.open();
					} else {
						this.close();
					}
				}

				open() {
					this.popover.hidden = false;
					this.trigger.setAttribute('aria-expanded', 'true');
				}

				close() {
					this.popover.hidden = true;
					this.trigger.setAttribute('aria-expanded', 'false');
				}
			}
		);
	}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cv-read-more"] && !Shopify.designMode) return;
  try {
    class CvReadMore extends HTMLElement {
		connectedCallback() {
			this.content = this.querySelector('.cv-read-more__content');
			this.toggle = this.querySelector('.cv-read-more__toggle');
			if (!this.content || !this.toggle) return;

			this.toggle.addEventListener('click', () => this.expand());

			this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
			this.resizeObserver.observe(this.content);

			if (document.fonts?.ready) {
				document.fonts.ready.then(() => this.checkOverflow());
			}
		}

		disconnectedCallback() {
			this.resizeObserver?.disconnect();
		}

		checkOverflow() {
			if (this.hasAttribute('data-expanded')) return;
			const overflowing =
				this.content.scrollHeight > this.content.clientHeight + 1;
			this.toggleAttribute('data-overflowing', overflowing);
		}

		expand() {
			this.setAttribute('data-expanded', '');
			this.toggle.setAttribute('aria-expanded', 'true');
		}
	}

	if (!customElements.get('cv-read-more')) {
		customElements.define('cv-read-more', CvReadMore);
	}
  } catch(e) { console.error(e); }
})();

})();
